module.exports = __webpack_public_path__ + "static/media/logoHQ.66979b41.png";